/**
 *
 * Asynchronously loads the component for ComingSoon
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { AuthPageLoading } from '../../components/AuthPageLoading/AuthPageLoading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "ComingSoon" */),
  loading: <AuthPageLoading />
})
